import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import * as _ from "lodash";
import { NgSelectComponent } from "@ng-select/ng-select";

@Component({
  selector: "checkbox-multiselect",
  templateUrl: "./checkbox-multiselect.component.html",
  styleUrls: ["./checkbox-multiselect.component.scss"],
})
export class CheckboxMultiselectComponent implements OnInit {
  @Input() filterDropdown;
  @Input() groupBy: string;
  @Input() placeholder: string;
  @Input() selectedFilterVals;
  @Input() buttonText: string;
  @Input() categoryAttribute: string;
  @Input() itemAttribute: string;
  @Input() numItemsShown: number;
  @Input() searchable: boolean;
  @Input() disabled: boolean;
  @Input() applyToFilter = false;

  @Output() filtersSelectedEvent = new EventEmitter();
  @Output() unselectAllFiltersEvent = new EventEmitter();
  @Output() clearItemEvent = new EventEmitter();

  lodash = _;
  appliedFilterVals: Array<any>;

  constructor() {}

  ngOnInit() {
    this.appliedFilterVals = this.selectedFilterVals;
  }

  compare(item1, item2) {
    if (
      _.has(item1, "field") &&
      _.has(item1, "subfield.id") &&
      _.has(item2, "field") &&
      _.has(item2, "subfield.id")
    ) {
      return (
        item1.field == item2.field && item1.subfield.id == item2.subfield.id
      );
    } else {
      return false;
    }
  }

  customFilterSearch(term: string, item) {
    term = term.toLowerCase();
    return (
      item.subfield &&
      item.subfield.name &&
      item.subfield.name.toLowerCase().indexOf(term) > -1
    );
  }

  applyFilters(select: NgSelectComponent) {
    this.filtersSelectedEvent.emit(this.selectedFilterVals);
    this.appliedFilterVals = this.selectedFilterVals;

    if (select) {
      select.close();
    }
  }

  filterSelected(event) {
    if (!this.applyToFilter) {
      this.appliedFilterVals = this.selectedFilterVals;
      this.filtersSelectedEvent.emit(event);
    }
  }

  onClose() {
    if (
      this.applyToFilter &&
      !_.isEqual(this.appliedFilterVals, this.selectedFilterVals)
    ) {
      this.applyFilters(null);
    }
  }
}
